module.exports = __webpack_public_path__ + "assets/img/8b49-bw.svg";